export const fontSizeRem = 0.6;
export const heightRem = 10;
